import { useLocalizedData } from "contexts/LocalizationContext/hooks";
import type { CalculateAmountProps } from "./OurCompensationTable.d";

const standardFeePercentage = 35;
const legalFeePercentage = 50;

const formatAmount = (amount: number) => Number(amount.toFixed(2).replace(/\.00$/, ""));

export const calculateAmount = (amount: CalculateAmountProps["amount"], type?: CalculateAmountProps["type"]) => {
  const amountNumber = Number(amount);
  const calculate = () => {
    switch (type) {
      case "standardFee":
        return (amountNumber * standardFeePercentage) / 100;
      case "standardCompensation":
        return (amountNumber * (100 - standardFeePercentage)) / 100;
      case "legalFee":
        return (amountNumber * legalFeePercentage) / 100;
      case "legalCompensation":
        return (amountNumber * (100 - legalFeePercentage)) / 100;
      default:
        return amount;
    }
  };

  const formattedAmount = formatAmount(Number(calculate()));

  return formattedAmount;
};

export const useCompensationValue = () => {
  const { getLocalizedNumber } = useLocalizedData();

  const getCompensationDAValue = (amount: number) =>
    amount % 1 === 0
      ? getLocalizedNumber(amount, {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        })
      : getLocalizedNumber(amount, {
          style: "currency",
          currency: "EUR",
          minimumFractionDigits: 2,
        });

  return { getCompensationDAValue };
};
